<div class="maintenance flex-1">
    <h1>{{ title }}</h1>
    <p>{{ description }}</p>
  </div>
  